<!-- Homepage marketing variant: only shown to EXISTING customers (recently bought) —
     a new customer has no purchase history, so this stays hidden for them. Uses the
     homepage section-title style + the larger Featured-style product cards. -->
<section *ngIf="homepage && recentlybought && recentlyView?.length" class="rv-home">
  <div class="rv-home-head text-center">
    <p class="section-label">Buy again</p>
    <h2 class="section-heading">Recently bought products</h2>
  </div>
  <app-featured-carousel [items]="recentlyView"></app-featured-carousel>
</section>

<div class="recent-viewed mt-5" *ngIf="!homepage && recentlyView && recentlyView.length > 0">
  <div class="">
    <p-toast></p-toast>
    <h5 *ngIf="frequentlyBought && recentlyView.length" class="mb-3 ms-3">Frequently Bought Together</h5>
    <h5 *ngIf="!frequentlyBought && !recentlybought && recentlyView.length" class="mb-3 ms-3">Recently Viewed Products</h5>
    <h5 *ngIf="!frequentlyBought && recentlybought && recentlyView.length" class="mb-3 ms-3">Recently Bought Products</h5>

    <div *ngIf="recentlyView.length" class="slider-wrapper position-relative" [class.no-scroll]="!canScroll">
      <button *ngIf="canScroll" style="left: -5px;" class="slick-prev arrow-btn" (click)="recentCarousel.navBackward($event)"
        aria-label="Previous products"><img class="arrow-icon arrow-icon--prev" src="/images/svg/dropdown.svg" alt=""></button>
      <button *ngIf="canScroll" style="right: -5px;" class="slick-next arrow-btn" (click)="recentCarousel.navForward($event)"
        aria-label="Next products"><img class="arrow-icon" src="/images/svg/dropdown.svg" alt=""></button>
      <p-carousel ngSkipHydration #recentCarousel class="slider" [value]="recentlyView" [numVisible]="5" [numScroll]="4" [circular]="true" [responsiveOptions]="recentResponsiveOptions" [showNavigators]="false" [showIndicators]="canScroll">
        <ng-template let-item pTemplate="item">
          <div class="custome-card">
            <app-product-card [item]="item" [isLogin]="isLogin" [i]="item._idx" [onClickCompare]="onClickCompare.bind(this)"
              [gridView]="true"></app-product-card>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>
</div>
<!-- <app-pop-up #popup [popupData]="popupData"></app-pop-up>
<app-shipping-fees-modal #popupShipFees [cart]="feesCart"></app-shipping-fees-modal> -->

<!-- <div class="cartpopup" [class.active]="addedToCart">
      <div class="d-flex justify-content-end">
          <a
            style="opacity: 1;"
            type="button"
            class="btn-close"
            (click)="closeAddtocart()"
          ></a>
      </div>
     <div>
      <div class="product d-flex">
        <img class="me-2" [src]="addedItem?.imageUrl ? addedItem.imageUrl:'./placeholder.svg'" alt="">
        <div class="w-100 d-flex flex-column justify-content-between">
          <h4 class="itemHeading">Item added to cart</h4>
          <div class="pname d-flex justify-content-between"><h5>{{addedItem?.productName}}</h5><span>{{addedItem?.price | currency:'USD'}}</span></div>
        </div>
       </div>
      </div>
      <div class="actionBtns d-flex mt-3">
        <button  (click)="closeAddtocart()" >keep Shopping</button>
        <button (click)="closeAddtocart()" routerLink="/shopping-cart">VIEW CART</button>
      </div>
</div> -->